import { useEffect, useState } from "react";
import validateForm from "features/maintenance/utils/validateForm";
import FieldRenderer from "../FieldRenderer";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import TaxBracketResource from "features/maintenance/resources/taxBracketResource";
import MaintenanceTable from "features/maintenance/components/MaintenanceTable";
import GridForm from "features/maintenance/pages/MaintenancePage/components/GridForm";
import MaintenanceForm from "features/maintenance/components/MaintenanceForm";
import { PersonOutlined } from "@mui/icons-material";
import DeleteConfirmationDialog from "features/maintenance/components/DeleteConfirmationDialog";
import { Button } from "@mui/material";
import DButton from "components/common/DButton";

// import DetailResource
export function TaxBracketForm() {
    return "test";
}

export default function TaxScheduleForm({
    resource,
    form,
    setForm,
    showValidation,
    items
}) {
    const [errors, setErrors] = useState({});
    const [subForm, setSubForm] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const [itemToDelete, setItemToDelete] = useState(null);

    useEffect(() => {
        setErrors(validateForm(resource.fields, form, items));
    }, [resource, form]);

    const filteredItems = form?.brackets
        ? form.brackets.filter((b) => !b.isDeleted)
        : [];

    const onSubformSave = () => {
        console.log("onSubformSave", { subForm });
        // Add
        if (!subForm?.id) {
            setForm((prevForm) => ({
                ...prevForm,
                brackets: [
                    ...(prevForm?.brackets ? prevForm.brackets : []),
                    { ...subForm, rowId: crypto.randomUUID() }
                ]
            }));
        } else {
            // edit
            setForm((prevForm) => ({
                ...prevForm,
                brackets: prevForm.brackets.map((b) =>
                    b.id === subForm.id ? subForm : b
                )
            }));
        }

        setDialogOpen(false);
    };

    const onSubformDelete = (row) => {
        // initializeDialog();
        setItemToDelete(row);
        setDeleteDialogOpen(true);
    };

    const handleDelete = () => {
        setForm((prevForm) => ({
            ...prevForm,
            brackets: (prevForm?.brackets ? prevForm.brackets : [])
                .filter((b) => {
                    const match =
                        (b.id || b.rowId) ===
                        (itemToDelete.id || itemToDelete.rowId);

                    if (!match) return true; // keep non-matching items

                    // If id is null → remove entirely
                    if (itemToDelete.id == null) {
                        return false;
                    }

                    // Otherwise → keep but mark as deleted
                    return true;
                })
                .map((b) =>
                    (b.id || b.rowId) ===
                    (itemToDelete.id || itemToDelete.rowId)
                        ? { ...b, ...itemToDelete, isDeleted: true }
                        : b
                )
        }));

        setDeleteDialogOpen(false);
        setSubForm({});
        setItemToDelete({});
    };

    const handleAdd = () => {
        setSubForm({});
        setDialogOpen(true);
    };

    return (
        <GridContainer spacing={1} direction="column">
            <GridItem xs>
                <GridContainer spacing={1} direction="column">
                    {resource.fields.map((field, index) => (
                        <GridItem key={field.name} xs={index === 0 ? 12 : 6}>
                            <FieldRenderer
                                key={field.name}
                                field={field}
                                form={form}
                                setForm={setForm}
                                errors={errors}
                                showValidation={showValidation}
                                resource={resource}
                            />
                        </GridItem>
                    ))}
                </GridContainer>
            </GridItem>
            <GridItem>
                <DButton xs fullWidth={false} onClick={handleAdd}>
                    Add
                </DButton>
            </GridItem>
            <GridForm
                resource={TaxBracketResource}
                form={subForm}
                setForm={setSubForm}
                showValidation
                items={filteredItems}
                filteredItems={filteredItems}
                handleEdit={(row) => {
                    setSubForm(row);
                    setDialogOpen(true);
                }}
                onDelete={onSubformDelete}
                onCancel={() => {
                    setSubForm({});
                    setDialogOpen(false);
                }}
                handleSave={onSubformSave}
                hasErrors={false}
                editableForm={MaintenanceForm}
                dialogOpen={dialogOpen}
                canSave
                pageIcon={<PersonOutlined />}
            />

            <DeleteConfirmationDialog
                open={deleteDialogOpen}
                title={`Delete ${resource.singular}`}
                message={`Are you sure you want to delete "${itemToDelete?.[resource.displayField]}"?`}
                onCancel={() => {
                    setDeleteDialogOpen(false);
                    setItemToDelete(null);
                }}
                onConfirm={handleDelete}
            />
        </GridContainer>
    );
}
